const Footer = () => {
  return (
    <footer className="relative border-t border-border bg-card/50 py-6">
      <div className="max-w-7xl mx-auto px-6 text-center">
        <p className="text-muted-foreground text-sm">
          © 2026 VeriChain. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
